function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgPickUp = function SvgPickUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.316.438a.6.6 0 01.424-.176h6.513a1.4 1.4 0 011.236.742l2.47 4.638 5.267.367c.116.008.287.027.464.1.266.112.588.312.858.506.257.185.554.429.714.65a.6.6 0 01.114.352v1.929a1.4 1.4 0 011.224 1.389V12.4a1.4 1.4 0 01-1.4 1.4h-3.085a3.401 3.401 0 01-6.695 0H11.197a3.401 3.401 0 01-6.704-.058l-2.145-.239a1.4 1.4 0 01-1.232-1.193l-.26-1.825a.6.6 0 01.038-.312l.727-1.782V6.643a1.4 1.4 0 011.445-1.399l11.074.354V.862a.6.6 0 01.176-.424zm1.024 5.18h8.247l-2.157-4.05a.2.2 0 00-.177-.106H15.34v4.155zm9.226 1.2H14.74a.59.59 0 01-.019 0L3.028 6.443a.2.2 0 00-.207.2v1.865a.6.6 0 01-.044.226l-.71 1.741.237 1.664a.2.2 0 00.176.17l2.035.227a3.401 3.401 0 016.683.063H22.42a3.401 3.401 0 016.695 0H32.2a.2.2 0 00.2-.2v-1.465a.2.2 0 00-.2-.2h-.424a.6.6 0 01-.6-.6V7.852a3.896 3.896 0 00-.33-.263 3.613 3.613 0 00-.618-.372c.001 0 .002 0 0 0a.639.639 0 00-.085-.011l-5.577-.389zm-8.582 2.077a.6.6 0 01.6-.6h2.33a.6.6 0 110 1.2h-2.33a.6.6 0 01-.6-.6zM7.85 11a2.2 2.2 0 100 4.4 2.2 2.2 0 000-4.4zm17.917 0a2.2 2.2 0 100 4.4 2.2 2.2 0 000-4.4z",
    fill: props.color
  }));
};
SvgPickUp.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgPickUp.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgPickUp;